import React from 'react';

import { OsmMarker } from './osm_marker';
import { GmapsMarker } from './gmaps_marker';

export function Marker(props) {
  return(
    props.useOsm ? <OsmMarker {...props} /> : <GmapsMarker {...props} />
  );
}
